module.exports = __webpack_public_path__ + "img/stepchar3.9c5a648f.png";